import { GeckoToastService } from '../../ui';
import { ConversationErrors } from './errorConstants';
const toastInstance = new GeckoToastService();

const parseNonStrings = (arr) => {
  return arr.filter((value) => {
    if (typeof value !== 'string') {
      console.warn(
        `Invalid safe value type in error ${value}<${typeof value}>`
      );
      return false;
    }
    return true;
  });
};

class GeckoError {
  constructor(error) {
    if (!error) {
      return (this.error = {
        raw: undefined,
        safe: undefined,
      });
    }

    if (
      error instanceof Error &&
      Object.values(ConversationErrors).includes(error.name)
    ) {
      error = {
        name: error.name,
        raw: error.error,
        safe: error.toArray(),
      };
    }

    // Multi-region issue where Lambda wraps the error response and we need to look at error.data
    if (error.data) {
      this.error = error.data;
    } else {
      this.error = error;
    }
  }
  render() {
    const hasContent = this.error.safe && this.error.safe.length;
    if (hasContent) {
      const safe = parseNonStrings(this.error.safe).join('\n');
      return toastInstance.error(safe);
    }
    const errorToastResponses = {
      [ConversationErrors.WEB_SAFE_AUTHORISATION_ERROR]:
        'Oops, it looks like you dont have permissions to access this.',
      [ConversationErrors.WEB_SAFE_NOT_FOUND_ERROR]:
        "The resource you requested doesn't exist",
    };

    const toastText =
      errorToastResponses[this.error.name] ||
      'Sorry, something went wrong! 😖 Please try again, and contact support if problems persist.';
    return toastInstance.error(toastText);
  }
  get safe() {
    if (!this.error.safe) {
      return [];
    }
    return parseNonStrings(this.error.safe);
  }
  get raw() {
    return this.error.raw;
  }
  // Used for extracting an errors object that can be passed straight to GeckoFields
  get fieldErrors() {
    if (this.raw.constructor === {}.constructor) {
      return this.raw;
    } else {
      return {};
    }
  }
}

const renderError = (error) => {
  console.error(error);
  new GeckoError(error).render();
};

export { renderError };
export default GeckoError;
